/* eslint-disable react/no-danger */
import React, { useEffect, useState, useRef } from 'react';
import { _ } from '_locales';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { colors } from '_styles';
import { goToTop } from '_helpers';
import parse from 'html-react-parser';
import { alert as alertSetup } from '_actions';
import goToCollectionRequirements from '../helpers';

// import style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Td = styled.td`
    height: 130px !important;
    position: relative;
    background-color: ${({ prevNextCurr }) => (prevNextCurr === 'curr' ? '#fff' : '#e3e3e3')};
    vertical-align:top;
    padding: 5px;
    box-sizing: border-box;
    box-shadow: 0 0 0 1px ${colors.LIGHT_GREY};

    
    cursor: ${({ disabled }) => ((disabled) ? 'pointer' : 'initial')};

    @media screen and (max-width: 500px) {
      height: 40px !important;
  
      span {
          text-align: center !important;
      }
    }

    ${(parentWidth < 631) && css`
        padding: 2px;
    `};

    ${(parentWidth < 501) && css`
      height: 40px !important;
      padding: 5px;
      span {
          text-align: center !important;
      }
    `};
`;

const EventContainer = styled.button`
  width: 100%;
  position: relative;
  margin-bottom: 5px;
  border: none;
  background-color: ${({ prevNextCurr }) => (prevNextCurr === 'curr' ? '#fff' : '#e3e3e3')};
  padding: 0;
  padding-left: 8px;
  cursor: pointer;
  display: flex;

  @media screen and (max-width: 500px) {
    width: 8px;
    height: 8px;
    padding: 0;
    flex: 33%;
    margin: 2px !important;
    justify-content: center;
  }

  ${(parentWidth < 631) && css`
    padding: 0;
  `};

  ${(parentWidth < 501) && css`
    width: 8px;
    height: 8px;
    flex: 33%;
    margin: 2px !important;
    justify-content: center;
  `};
`;

const Circle = styled.div`
  border-radius: 50% !important;
  width: 8px !important;
  height: 8px !important;
  min-width: 8px !important;
  min-height: 8px !important;
  max-width: 8px !important;
  max-height: 8px !important;
  margin-top: 3px !important;

  ${(parentWidth < 631) && css`
     margin-top: 2px !important;
  `};
`;

const EventTitle = styled.p`
  font-size: 12px !important;
  font-weight: 500 !important;
  text-align: left !important;
  color: #0a1514 !important;
  margin: 0 5px !important;

  text-transform: capitalize;

  @media screen and (max-width: 500px) {
    display: none !important;
  }

  ${(parentWidth < 631) && css`
     margin: 0 2px !important;
  `};

  ${(parentWidth < 501) && css`
    display: none !important;
    margin: 0 5px !important;
  `};

  p {
    margin: 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
`;

const EventOuterContainer = styled.div`
  @media screen and (max-width: 500px) {
    display: inline-flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  padding-top: 4px !important;

  ${(parentWidth < 501) && css`
    display: inline-flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  `};
`;

const Span = styled.span`
  font-size: 16px !important;
  font-weight: 500 !important;
  text-align: left !important;
  color: #717171;
  display: block;
`;
// End style

const EventsDay = ({
  i,
  collection,
  allEventsObj,
  setEventInfo,
  disabled,
  setIsModalOpen,
  setModalAlertingMessage,
  month,
  curYear,
  prevNextCurr
}) => {
  const eventRef = useRef(null);
  const [comment, setComment] = useState('');

  const history = useHistory();

  const setDayCollection = () => {
    goToTop();
    setEventInfo({
      month: prevNextCurr,
      day: Object.keys(allEventsObj).findIndex((index) => index === i.toString())
    });
  };

  useEffect(() => {
    if (
      comment
      && comment.length
      && comment === 'holiday'
    ) {
      setIsModalOpen(true);
      setModalAlertingMessage(_('cal.holiday_no_collection'));
      setComment('');
    }

    if (
      comment
      && comment.length
      && comment === 'tree'
    ) {
      setIsModalOpen(true);
      setModalAlertingMessage(_('cal.christmas_tree_drop_off'));
      setComment('');
    }
  }, [comment]);

  useEffect(() => {
    if (eventRef.current) {
      eventRef.current.style.setProperty('margin-top', '0px', 'important');
      eventRef.current.style.setProperty('margin-right', '0px', 'important');
    }
  }, []);

  return (
    <Td
      prevNextCurr={prevNextCurr}
      disabled={disabled}
      onClick={() => ((disabled) ? setDayCollection() : null)}
    >
      <Span>{i}</Span>
      <EventOuterContainer>
        {
          allEventsObj[i]
            .map((res, index) => {
              const id = `collection-${res.id}`;
              if (id in collection) {
                const countOfEvents = allEventsObj[i];
                const {
                  title,
                  colour,
                } = collection[id];

                const modifiedTitle = title?.toLowerCase().endsWith(' collection') ? title?.toLowerCase().replace(' collection', '') : title?.toLowerCase();

                return (
                  <EventContainer
                    prevNextCurr={prevNextCurr}
                    key={id}
                    onClick={() => (
                      (!disabled)
                        ? [
                          goToTop(),
                          goToCollectionRequirements(
                            id,
                            collection,
                            history,
                            setComment,
                            month,
                            i,
                            curYear
                          )
                        ]
                        : null
                    )}
                    aria-label={`${title} on ${month} ${i}`}
                    style={{ marginTop: (index === 0) ? '5px' : '0px' }}
                    countOfEvents={countOfEvents}
                  >
                    <Circle style={{ backgroundColor: `#${colour}` }} />
                    <EventTitle ref={eventRef} countOfEvents={countOfEvents}>
                      <div dangerouslySetInnerHTML={{ __html: modifiedTitle }} />
                    </EventTitle>
                  </EventContainer>
                );
              }
              return null;
            })
        }
      </EventOuterContainer>
    </Td>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setIsModalOpen: (isModalOpen) => dispatch(alertSetup.setIsModalOpen(isModalOpen)),
  setModalAlertingMessage: (modalAlertingMessage) => dispatch(
    alertSetup.setModalAlertingMessage(modalAlertingMessage)
  ),
});

export default connect(null, mapDispatchToProps)(EventsDay);
